import classNames from "classnames";
import styled from "styled-components";

import { number } from "common/formats";

export function Paginator({
    loading, limit, page, count, next, results_length, onPageChange
}) {
    const clickPrev = (e) => {
        if (page === 1) return;
    
        onPageChange(page - 1);
    };
    
    const clickNext = (e) => {
        if (!next) return;
    
        onPageChange(page + 1);
    };
    
    const formatTotalCount = () => {
        if (count === null && results_length < limit && page === 1) {
            return results_length;
        }

        if (count === null) return "many";

        if (results_length === limit && count === 0) return "many";
        
        return number(count);
    };
    
    const computeRange = () => {
        let endrange;
        if (count === null || count === 0) {
            if (results_length < limit) {
                endrange = results_length;
            } else {
                endrange = page * limit;
            }
        } else {
            endrange = Math.min(page * limit, count);
        }
        
        return {
            start: number(Math.max(limit * (page - 1) + 1)),
            end: number(endrange)
        };
    };
    
    if (loading) {
        return (
            <div className="paginator">
                <div className="loader text-input__loading--line medium" />
            </div>
        );
    }
    
    const { start, end } = computeRange();
    
    return (
        <Container className="paginator">
            <Info className="info">{start}-{end} of <span className="total">{formatTotalCount()}</span></Info>
            <Controls className="controls">
                <div onClick={clickPrev} className={classNames("prev", { inactive: page === 1 })}>Prev</div>
                <div className="separator">|</div>
                <div onClick={clickNext} className={classNames("next", { inactive: !next })}>Next</div>
            </Controls>
        </Container>
    );
}

Paginator.defaultProps = {
    loading: false,
    limit: 0,
    page: 1,
    count: null,
    next: false,
    results_length: 0,
    onPageChange: () => {}
};

const Container = styled.div(({ theme }) => `
    font-family: ${theme.text.regular};
    font-size: ${theme.fontSizeMedium};
    margin-left: 10px;
    display: flex;
    align-items: center;
`);

const Info = styled.div`
    margin-right: 10px;
`;

const Controls = styled.div`
    display: flex;

    .separator {
        margin: 0 5px;
    }

    .prev,
    .next {
        &.inactive {
            color: ${({ theme }) => theme.colors["gray-light"]};
            cursor: not-allowed;
        }

        &:not(.inactive) {
            &:hover {
                text-decoration: underline;
                cursor: pointer;
                color: ${({ theme }) => theme.colors["green-mid"]};
            }
        }
    }
`;
